import ky from "ky";
import { BASE_URL } from "./EndPoints";

const getToken = () => {
    const token = localStorage.getItem("token");
    return token;
}

export const createB2BAPI = (navigate) => {

    return ky.create({
        prefixUrl: BASE_URL,
        timeout: 30000, // Set timeout to 10 seconds
        hooks: {
            beforeRequest: [
                (request) => {
                    request.headers.set("Authorization", `Bearer ${getToken()}`);
                }
            ],
            beforeError: [
                async (error) => {
                    const { response } = error;

                    if (response.status === 401) {
                        localStorage.clear()
                        navigate("/login"); // Navigate to index page
                        return;
                    }
                    return await response.json();
                }
            ],
            afterResponse: [
                async (response) => {
                    return response;
                }
            ],
        },
    });
};

